import ApiRequests from "../apiRequests";

class MailingListService extends ApiRequests {
  constructor() {
    super("mailing-list");
  }
}

export default MailingListService;
